<template>
<!-- eslint-disable max-len -->
<div class="root">
  <template v-if="isLoadingComplete && !hasLoadedData">
    <div
      style="width: 100%; height: 100%;"
    >
      <div style="display: flex; width: 100%; height: 100%; min-height: 200px; min-width: 400px; align-items: center; justify-content: center;">
        <div style="background-color: white; border-radius: 5px; padding: 10px; color: black; font-size: 150%; box-shadow: 2px 2px 25px 1px;">
          You are not assigned any gamulations!  Please contact support to resolve this issue.
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-if="!isLoadingComplete">
        <blade-spinner>
          <div v-if="loadMessage && loadMessage.length > 0" slot="spinner-neighbor" style="margin-top: 10px; font-size: 24px;">
            {{loadMessage}}
          </div>
        </blade-spinner>
      </div>
      <div
        v-else-if="isGameLocked && showGameLock"
        style="width: 100%; height: 100%;"
      >
        <div
          style="
            display: flex;
            width: 100%;
            height: 100%;
            min-height: 200px;
            min-width: 400px;
            align-items: center;
            justify-content: center;
          "
        >
          <div
            style="
              background-color: white;
              border-radius: 5px;
              padding: 10px;
              color: black;
              font-size: 150%;
              box-shadow: 2px 2px 25px 1px;
            "
          >
            <div v-html="gameUnlockMessage"></div>
          </div>
        </div>
      </div>
      <div v-else-if="classToTest != null && classToTest._id != null && isStudent && !hasPaid"
        style="width: 100%; height: 100%;"
      >
        <!-- TODO @Ian: change the alerts however you want? -->
        <div style="display: flex; width: 100%; height: 100%; min-height: 200px; min-width: 400px; align-items: center; justify-content: center;">
          <class-purchase-flow
            :course="classToTest"
            @course-purchased="(free)=>{ hasPaid = true; flashSuccess( { message: free ? `Joined ${classTypeNameLower} successfully` : `${classTypeName} purchased successfully` } ); }"
            @course-already-paid="()=>{ hasPaid = true; }"
          />
        </div>
      </div>
      <div v-else-if="classToTest != null && !hasLoadedData"
        style="width: 100%; height: 100%;"
      >
        <div style="display: flex; width: 100%; height: 100%; min-height: 200px; min-width: 400px; align-items: center; justify-content: center;">
          <div style="background-color: white; border-radius: 5px; padding: 10px; color: black; font-size: 150%; box-shadow: 2px 2px 25px 1px;">
            The settings for this {{classTypeName}} require you to be assigned to a Group before you can continue. Please try again later.
          </div>
        </div>
      </div>
      <div v-else class="content">
        <div
          class="game-title-bar"
          :style="titleBarStyle"
        >
          <!--
            Never use v-html with end-user generated content, because it's a vector for XSS attacks
          -->
          <h1
            class="animated"
            :class="{
              fadeInLeft: !(game && game.titleBarXFromRight),
              fadeInRight: (game && game.titleBarXFromRight),
            }"
            v-html="title"
          ></h1>
        </div>
        <img v-if="!(game.titleScreenNoInsetImage)" :src="heroImage" class="title-image"/>
        <button
          v-focus
          class="btn start-button"
          :style="startButtonStyle"
          :disabled="!hasLoadedData"
          tag="button"
          @click.prevent="handleGameStart"
        >
          <span v-html="game.startButtonText || 'Start'"></span>
        </button>
        <change-password-prompt
          v-if="showChangePasswordPrompt"
          @close="() => { showChangePasswordPrompt = false; }"
        />
      </div>
    </transition>

    <div v-if="!(game.titleScreenNoBottomBar)" class="footer-background">
      <footer style="height: 100%; pointer-events: none; display: flex; flex-direction: row; align-items: flex-end; justify-content: space-between; padding: 0 20px;">
        <span class="float-left" style="height: 100%;">
          <span style="height: 100%; display: flex; flex-direction: row;">
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks
            -->
            <span
              style="
                height: 100%;
                align-self: center;
                text-align: left;
                display: flex;
                flex-flow: column nowrap;
                justify-content: center;
              "
              v-html="
                (activeClass || activeEnvironment).revisionText || activeEnvironment.revisionText || 'REV 3.0 JANUARY 2020'
              "
            ></span>
          </span>
        </span>
        <span class="float-right" style="height: 100%;">
          <span style="height: 100%; display: flex; flex-direction: row; align-items: center; justify-content: flex-end;">
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks
            -->
            <span style="text-align: right;" v-html="activeEnvironment.creditsText || 'Powered by '"></span>
            <img
              v-if="!(activeEnvironment.noCreditsLogo)"
              :src="resolveAssetPath(activeEnvironment.creditsLogo || 'redmerU_loginLogo.png', 'ui/customer')"
              class="logo"
            />
          </span>
        </span>
      </footer>
    </div>
  </template>
</div>
</template>

<script>
import Vue from 'vue';
import {
  mapActions,
  mapMutations,
  mapGetters
} from 'vuex';
import ClassPurchaseFlow from '@/components/braintree/ClassPurchaseFlow';
import ChangePasswordPrompt from '@/components/ui/modals/ChangePasswordPrompt';
import { preloadAssetsFromObject, markInitialGamePreloadComplete } from '@/utils/asset-util';

export default {
  components: {
    ClassPurchaseFlow,
    ChangePasswordPrompt
  },
  data() {
    return {
      loadMessage: 'Loading...',
      hasLoadedData: false,
      isLoadingComplete: false,
      showGameLock: false,
      showChangePasswordPrompt: false,
      hasPaid: false
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'entryState',
      'demo',
      'group',
      'game',
      'canSelectGame',
      'canRestartGame',
      'classTypeName',
      'classTypeNameLower',
      'activeClass',
      'me'
    ]),
    gameUnlockDate() {
      if (this.activeClass && this.activeClass.gamulationUnlockDate) {
        return new Date(this.activeClass.gamulationUnlockDate);
      }
      return null;
    },
    isGameLocked() {
      return this.gameUnlockDate
        && (this.gameUnlockDate > new Date());
    },
    timeStringOptions() {
      return {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      };
    },
    gameUnlockTimeString() {
      return this.gameUnlockDate
        ? this.gameUnlockDate.toLocaleString(undefined, this.timeStringOptions)
        : '';
    },
    gameUnlockMessage() {
      const lockMessage =
        (this.activeClass && this.activeClass.lockMessage)
          ? this.activeClass.lockMessage
          : 'You cannot progress further at this time. To continue, refresh after: {time}';
      return lockMessage.replace('{time}', this.gameUnlockTimeString);
    },
    heroImage() {
      return this.resolveAssetPath(this.game.titleImage || 'titleScreen_featureImage-HSG.png', 'ui/customer');
    },
    groupId() {
      return this.$route.params.groupId;
    },
    isDemo() {
      return !this.groupId;
    },
    isStudent() {
      return this.me.roles.some(r => r._id === 'student');
    },
    classToTest() {
      // eslint-disable-next-line no-underscore-dangle
      if (this.activeClass != null && !this.activeClass._invalid) {
        return this.activeClass;
      } else if (this.me.classes != null && this.me.classes[0] != null) {
        return this.me.classes[0];
      }
      return null;
    },
    titleBarStyle() {
      return {
        height: this.game.titleBarHeight ? this.game.titleBarHeight : undefined,
        width: this.game.titleBarWidth ? this.game.titleBarWidth : undefined,
        bottom: this.game.titleBarY ? this.game.titleBarY : undefined,
        left: this.game.titleBarX ? (!(this.game.titleBarXFromRight) ? this.game.titleBarX : 'unset') : undefined,
        right: this.game.titleBarX ? (this.game.titleBarXFromRight ? this.game.titleBarX : 'unset') : undefined,
        outline: (this.game.titleBarNoBorder || this.game.titleBarNoBackground)
          ? 'none'
          : (this.game.titleBarBorderColor ? `3px solid ${this.game.titleBarBorderColor || 'white'}` : undefined),
        'background-image':
          this.game.titleBarNoBackground
            ? 'none'
            : (this.game.titleBarBackground
              ? `url(${this.resolveAssetPath(this.game.titleBarBackground, 'ui/customer')})`
              : undefined),
        'background-color':
          (this.game.titleBarNoBackground || this.game.titleBarBackground)
            ? 'rgba(0,0,0,0)'
            : (this.game.titleBarBackgroundColor
              ? this.game.titleBarBackgroundColor
              : undefined),
        // 'text-align':
        //   (this.game.titleBarWidth
        //     || (this.game.titleBarX && this.game.titleBarX.length > 0 && !(this.game.titleBarX.startsWith('0')))
        //   )
        //     ? (this.game.titleBarXFromRight ? 'right' : 'left')
        //     : undefined,
      };
    },
    startButtonStyle() {
      return {
        height: this.game.startButtonHeight ? this.game.startButtonHeight : undefined,
        width: this.game.startButtonWidth ? this.game.startButtonWidth : undefined,
        bottom: this.game.startButtonY ? this.game.startButtonY : undefined,
        left: this.game.startButtonX ? (!(this.game.startButtonXFromRight) ? this.game.startButtonX : 'unset') : undefined,
        right:
          this.game.startButtonX
            ? (this.game.startButtonXFromRight ? this.game.startButtonX : 'unset')
            : (this.game.titleScreenNoInsetImage ? 'unset' : undefined),
        margin: (!(this.game.startButtonX) && this.game.titleScreenNoInsetImage ? '0 auto' : undefined),
      };
    },
    shouldUseCourseTitle() {
      return this.activeClass != null && this.activeClass.courseName;
    },
    title() {
      if (this.activeClass != null && this.activeClass.courseName
        && !(this.game.titleOverridesClass)) {
        return this.activeClass.courseName;
      }
      return this.game.title || 'REDMERU GAMULATION';
    }
  },
  methods: {
    ...mapActions([
      'getShouldDefaultToHub',
      'startDemo',
      'getMyGroup',
      'flashSuccess',
      'playSound',
      'getActiveGameSetGames'
    ]),
    ...mapMutations([
      'setAudioPlaying',
      'setAudioPause',
    ]),
    tempAlertWrapper(str) {
      // TODO: update alert to use better UX?
      // eslint-disable-next-line no-alert
      alert(str);
    },
    async tryLoadHubPage() {
      try {
        // We only skip the hub for students with a single accessible item (games + classes === 1
        // && no games from game sets).  Therefore we only need to do the getActiveGameSetGames
        // check if the user is a student who has only one item.
        if (!await this.getShouldDefaultToHub()) {
          return false;
        }

        this.$router.replace('/hub');
        return true;
      } catch (err) {
        console.error('Error while loading game sets from demo page, see below...');
        console.error(err);
      }
      return false;
    },
    async playStartButtonSound() {
      console.log(this.game.startButtonSound);
      if (this.game.startButtonSound) {
        await Vue.nextTick();
        this.playSound({ sound: this.game.startButtonSound, soundIsUnstoppable: true });
      }
    },
    async handleGameStart() {
      this.setAudioPlaying(true);
      this.setAudioPause(false);
      await this.playStartButtonSound();
      if (this.isGameLocked) {
        this.showGameLock = true;
      } else {
        this.showGameLock = false;
        this.$router.push(this.entryState);
      }
    }
  },
  async created() {
    this.isLoadingComplete = false;
    try {
      if (this.isDemo) {
        if (this.demo) {
          this.startDemo();
        }

        if (await this.tryLoadHubPage()) {
          return;
        }
      }

      for (let i = 3; i > 0; --i) {
        const skipLegacyAssets = false;
        try {
          const { groupId } = this;

          this.loadMessage = 'Loading save info...';

          await this.getMyGroup(this.groupId ? { groupId } : {});
          this.hasLoadedData = true;
          if (this.isDemo) return this.$router.replace(`/groups/${this.group._id}`);

          this.loadMessage = 'Loading gamulation info...';
          await preloadAssetsFromObject([this.heroImage], undefined, undefined, undefined, skipLegacyAssets);

          this.loadMessage = 'Loading gamulation assets (0%)...';
          // Only wait for backgrounds, characters, and intro/character selection avatars to load
          // await preloadAssetsFromObject(this.$store.state.game, false, /background|character|intro|selected/i, (perc) => {
          //   this.loadMessage = `Loading gamulation assets (${perc}%)...`;
          // }, skipLegacyAssets);

          await preloadAssetsFromObject(this.$store.state.game.requiredAssets, false, undefined, (perc) => {
            this.loadMessage = `Loading gamulation assets (${perc}%)...`;
          }, skipLegacyAssets);

          markInitialGamePreloadComplete(skipLegacyAssets);

          // Preload the rest of the game images, but don't wait
          // preloadAssetsFromObject(this.$store.state.game);

          if (this.activeClass && this.activeClass.skipGameStart) {
            this.handleGameStart();
          }

          return;
        } catch (err) {
          if (this.$router.handleGameError(err)) {
            if (!this.groupId) {
              await this.tryLoadHubPage();
            }
            return;
          }
        }
      }
      this.$router.showGameErrorCritical();
    } finally {
      await this.$nextTick();
      this.isLoadingComplete = true;
      if (!(this.hasLoadedData)) {
        this.$router.replace('/hub');
      }
    }
  },
  mounted() {
    if (this.me.promptChangePassword) {
      this.showChangePasswordPrompt = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.root {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-image: var(--titleBackground);
  background-size: cover;
  background-repeat: no-repeat;
}

// New style UI
.content {
  width: 100%;
  height: 100%;
}

.game-title-bar {
  position: absolute;
  left: 0;
  bottom: 625px;
  width: 100%;
  overflow: visible;

  display: flex;
  align-items: center;

  outline: 3px solid white;
  border-radius: 3px;
  background-color: rgba(0,0,0,0.6);
  text-align: center;

  h1 {
    width: 100%;
    padding: 30px;
    color: white;
    font-size: 70px;
  }
}

.title-image {
  position: absolute;
  left: 540px;
  bottom: 180px;
  width: 520px;
  height: 390px;

  object-fit: cover;
  background-color: transparent;
  border-radius: 5px;
  border: 2px solid white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 25px 0 rgba(0, 0, 0, 0.4);
}

.start-button {
  position: absolute;
  right: 540px;
  bottom: 114px;

  height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  font-size: 1.5em;
  border-width: 1px !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 25px 0 rgba(0, 0, 0, 0.4);
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  font-size: 1em;
  font-weight: bold;
  color: white;
}

.footer-background {
  position: absolute;
  background-color: rgba(0,0,0,0.6);
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: calc(50px + 0.75em);
}

.logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-left: 20px;
  //border: 1px solid rgba(255,255,255,0.8);
  border-radius: 2px;
  position: relative;
  bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/GameStart.vue